import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { RaciService } from '../../services/raci.service';

/**
 * Handles raci checklist pane
 */
@Component({
  selector: 'raci-checklist-pane',
  templateUrl: './raci-checklist-pane.component.html',
  styleUrls: ['./raci-checklist-pane.component.css'],
})

export class RaciChecklistPaneComponent implements OnDestroy {
  /**
 * Array to store the task checklist
 */
  taskChecklist = [];

  /**
   * Array to store subscriptions
   */
  private subscriptions: Array<Subscription> = new Array<Subscription>();

  /**
   * Input setter for the checklist data
   */
  @Input() set checklist(value: any) {
    if (value) {
      this.taskChecklist = value;
    }
  }

  /**
   * Constructor
   * @param raciService RaciService
   */
  constructor(private raciService: RaciService) { }

  /**
   * Lifecycle hook that is called when the component is destroyed
   */
  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => { subscription.unsubscribe() });
  }

  /**
   * Event handler for updating the checklist item status
   * @param event Event object
   * @param checklistItem Checklist item object
   */
  onUpdateChecklistItemStatus(event: any, checklistItem: any) {
    this.subscriptions.push(this.raciService.updateChecklistItem(checklistItem.projectChecklistId, checklistItem.checklistItemStatus).subscribe((data) => {
      if (!data) {
        const item = this.taskChecklist.find(x => x.Name == checklistItem.checklistName);
        if (item) {
          item.itemStatus = !item.itemStatus;
        }
      }
    }));
  }
}
